import { MediumModalCreateEdit } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { valueOrDefaultValue } from '../../../../../../utils/globals/valueOrDefaultValue'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { PaymentMethodModelType } from '@teinor/erp/types/company/config/paymentMethod'
import TableWithoutVirtualListing from '../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { PaymentMethodDateModelAdd, PaymentMethodDateModelType } from '@teinor/erp/types/company/config/paymentMethod/paymentMethodDate'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { DeleteRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { TableWithoutDefaultRowRenderer } from '../../../../../../baseComponents/TwinTable/TableWithCustomVirtualListing'
import { TableWithoutVirtualListingRowProps } from '../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { nanoid } from 'nanoid'
import { InputWithLabelMarginIntegerStateLess } from '../../../../../../forms/Input'
import InputDiscount from '../../../../../../forms/Input/InputDiscount'
import { getISOCurrencyMain } from '../../../../../../utils/reducers/getters'
import { getCurrencySymbol } from '../../../../../../utils/globals/price'
import { BeforeSubmitHandler } from '../../../../../../forms/TwinForm/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { PaymentTypesPayload } from '../../../../../../utils/reducers/payments/paymentTypes'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { addDictionaryExtraLine } from '../../../../../../utils/globals/dictionary'
import { CustomSelectWithSearchBar } from '../../../../../../forms/CustomSelect'
import { emptyExtraLineFirstSortFunction } from '../../../../../../forms/CustomSelect/functions'
interface PaymentMethodDateModeAddExtended extends PaymentMethodDateModelAdd {
    subId?: string
}
type ModalCEConfigPaymentMethodProps = ModalEditComponentProps & ReduxPaymentTypes & {}

const ModalCEConfigPaymentMethod: React.FC<ModalCEConfigPaymentMethodProps> = ({ allRowData, userPermissions, paymentTypes, ...rest }) => {
    const { t } = useTwinTranslation()
    const { paymentMethodDates, customRowRender, deleteRow, changeField, beforeSubmit } = useModalCEConfigPaymentMethodLogic({allRowData})
    const currencyMain = useMemo(() => getISOCurrencyMain(), [])
    const avaliableItems = useMemo(() => { return { 0: { name: '%' }, 1: { name: getCurrencySymbol(currencyMain) } } }, [currencyMain])
    const paymentTypesMemo = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentTypes?.all))) , [paymentTypes?.all])
    const fields: FormRender<PaymentMethodModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]
    const lastRowIndex = paymentMethodDates && paymentMethodDates.length > 1 ? paymentMethodDates?.length - 2 : 0

    const columns: ColumnTableSchema<PaymentMethodDateModelType> = [
        {
            id: 'day',
            width: 100,
            dataKey: 'day',
            label: t('nDay', 'Día'),
            toolTip: t('dayPaymentTooltip', 'Indica los días de vencimiento contados desde la fecha de la factura'),
            customRender: (_parameterValue, allRowData) => <InputWithLabelMarginIntegerStateLess label='' hideLabel={true} value={allRowData.day} onChange={(value) => changeField(allRowData.rowIndex, 'day', value)} />
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            toolTip: t('quantityPaymentTooltip', 'Indica la cantidad, en porcentaje o dinero de este pago. Si dejas la cantidad vacía, se autocalculará con el resto que esté vacía'),
            customRender: (_parameterValue, allRowData) => allRowData.rowIndex !== lastRowIndex ? <InputDiscount label='' CurrencyId={currencyMain} maxDiscount={{ maxPercentageDiscount: 100, maxTotalDiscount: Infinity, maxUnitDiscount: Infinity }} onChange={(value) => changeField(allRowData.rowIndex, 'quantity', value)} avaliableItems={avaliableItems} value={{discount: allRowData.quantity, typeDiscount: allRowData.type_quantity || 0}}/> : <span><TwinTrans transKey='rest'>Resto</TwinTrans></span>, 
            className: 'overflow-visible'
        },
        {
            id: 'PaymentTypeId',
            dataKey: 'PaymentTypeId',
            label: t('paymentTypeN', 'Tipo de pago'),
            customRender: (parameterValue, allRowData) => <CustomSelectWithSearchBar items={paymentTypesMemo} label='' className='w-full custom_select_hide_label height_28' sortItems={true} sortFunction={emptyExtraLineFirstSortFunction} value={parameterValue} onChange={(value) => changeField(allRowData.rowIndex, 'PaymentTypeId', parseInt(value))} />,
            className: 'overflow-visible w-full'
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                return <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => deleteRow(allRowData.rowIndex)} />
            },
            className: 'overflow-visible'
        }
    ]

    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <MediumModalCreateEdit fields={parsedFields} url={'/api/app/config/payment/paymentMethod/updatePaymentMethod'} translations={{ title: t('editPaymentMethod', 'Editar método de pago'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} beforeSubmit={beforeSubmit} >
                <TableWithoutVirtualListing columns={columns} data={paymentMethodDates} rowRenderer={customRowRender}/>
            </MediumModalCreateEdit>
        )
    }
    return (<MediumModalCreateEdit fields={fields} url={'/api/app/config/payment/paymentMethod/createPaymentMethod'} translations={{
        title: t('createPaymentMethod', 'Crear método de pago'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} beforeSubmit={beforeSubmit} >
        <TableWithoutVirtualListing columns={columns} data={paymentMethodDates} rowRenderer={customRowRender} />
    </MediumModalCreateEdit>)
}

interface ModalCEConfigPaymentMethodLogicProps {
    allRowData?: RowData
}

const useModalCEConfigPaymentMethodLogic = ({ allRowData }: ModalCEConfigPaymentMethodLogicProps) => {
    const [paymentMethodDates, setPaymentMethodDates] = useState<PaymentMethodDateModeAddExtended[] | null>(null)

    const beforeSubmit: BeforeSubmitHandler = useCallback((vals) => {
        vals.paymentMethodDates = paymentMethodDates?.slice(0, paymentMethodDates.length-1)
        return true
    }, [paymentMethodDates])

    const getData = useCallback(async () => {
        let myData: PaymentMethodDateModeAddExtended[] = []
        if(allRowData?.id){
            const result = await twinFetchPostJSON('/api/app/config/payment/paymentMethod/getPaymentMethodInstanceComplete', {id: allRowData.id})
            if(result){
                myData = result.PaymentMethodDates
            }
        }
        myData.push({subId: 'addButton'})
        setPaymentMethodDates(myData)
    }, [allRowData?.id])

    const changeField = useCallback((rowIndex: number, keyValue: string, value: any) => {
        setPaymentMethodDates((old) => {
            if(!old){
                return old
            }
            const copy = JSON.parse(JSON.stringify(old))
            if(keyValue === 'quantity'){
                copy[rowIndex]['quantity'] = value.discount
                copy[rowIndex]['type_quantity'] = value.typeDiscount
            }else{
                copy[rowIndex][keyValue] = value
            }
            return copy
        })
    }, [setPaymentMethodDates])

    const deleteRow = useCallback((rowIndex: number) => {
        setPaymentMethodDates((old) => {
            if (!old) {
                return old
            }
            const copy = JSON.parse(JSON.stringify(old))
            copy.splice(rowIndex, 1)
            return copy
        })
    }, [setPaymentMethodDates])

    const addRow = useCallback(() => {
        setPaymentMethodDates((old) => {
            if(!old){
                return old
            }
            const lastOne = old.length > 1 ? old[old.length -2] : null
            const copy = JSON.parse(JSON.stringify(old))
            copy.splice(copy.length - 1, 0, { subId: nanoid(), day: lastOne?.day !== undefined ? parseInt(String(lastOne.day || 0)) + 1 : 0})
            return copy
        })
    }, [setPaymentMethodDates])

    const customRowRender = useCallback((props: TableWithoutVirtualListingRowProps) => {
        if(props.rowData.subId === 'addButton'){
            return (
                <div className='cursor-pointer text-center bg-gray-EF py-8 w-full text-gray-51 ' onClick={addRow}>
                    <TwinIcon className='mr-10' icon={faPlus} />
                    <TwinTrans transKey='addRow'>Añadir fila</TwinTrans>
                </div>
            )
        }
        return <TableWithoutDefaultRowRenderer {...props} key={props.rowData?.subId || props.rowData?.id} className='overflow-visible'/>
    }, [addRow])

    useEffect(() => {
        getData()
    }, [getData])

    return { paymentMethodDates, customRowRender, deleteRow, changeField, beforeSubmit }
}

const paymentTypesDispatch = {
    setPaymentTypes: (payload: PaymentTypesPayload) => ({ type: 'CHANGE_PAYMENTTYPES', payload }),
}

export type ReduxPaymentTypes = ConnectedProps<typeof PaymentTypesConnect>
const mapPaymentTypesConnector = (state: AllReduxPayloads) => ({ paymentTypes: state.paymentTypes })
const PaymentTypesConnect = connect(mapPaymentTypesConnector, paymentTypesDispatch)
const PaymentTypesConnectLoading = withLoading(ModalCEConfigPaymentMethod, [{ fetchUrl: '/api/app/config/payment/paymentType/getAllPaymentTypes', propName: 'paymentTypes', setFunctionName: 'setPaymentTypes' }])
const ModalCEConfigPaymentMethodConnect = PaymentTypesConnect(PaymentTypesConnectLoading)

export default ModalCEConfigPaymentMethodConnect